import React, { HTMLAttributes, useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import Layout from "components/Layout";
import { Hooks, Util } from "@xt/xtbase";
const { useDocumentWidth } = Hooks;
import Idodetail from "@/assets/images/academy/idodetail.png";
import Idodetails from "@/assets/images/academy/idos.png";

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  const isMobile = (useDocumentWidth() ?? 0) <= 768;
  useEffect(() => {
    const htmlEl = document.documentElement;
    htmlEl.style.fontSize = "39px";
  }, []);

  return (
    <Layout>
      <div className={cx(styles.ido, className)}>
        <img src={isMobile ? Idodetails : Idodetail} />
        <div className={cx(styles.idotext, className)}>
          <p>
            {" "}
            If there is a crypto related project in need of capital, one of the methods to obtain it is through Initial DEX Offering, or IDO. It is a relatively
            new type of decentralised and permissionless platform. The majority of projects aim to launch a coin or token via a decentralised exchange, meaning
            that it is performed Peer-to-Peer (P2P) and without an intermediary body. Enabling a new way to fundraise in the crypto space.{" "}
          </p>
          <p>
            {" "}
            When an organisation wants to launch an IDO, this means the project aims to launch a token or coin through this decentralised liquidity exchange.
            This takes place as a liquidity pool where traders can exchange tokens, crypto coins, and stablecoins. IDO’s are the successor of ICO’s (Initial
            Coin Offerings), and IEO’s (Initial Exchange Offerings), however, with some key differences. ICO’s for instance, have a lack of screening by an
            intermediary, which potentially poses a threat to investors. IEO’s, on the other hand, centralising was the main concern as it could lead to a
            higher risk of susceptibility to theft and cyber scams. For these reasons, IDO’s quickly became popular among those launching a new coin or token.{" "}
          </p>
          <h5> Wanting to see a great example of an IDO in action? Click here to see how you can get involved with IDO with our launchpad. </h5>
        </div>
      </div>
    </Layout>
  );
};

export default observer(Main);
// export default Main;
